(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-video"] && !Shopify.designMode) return;
  try {
    var GESTURES = ['pointerdown', 'touchstart', 'keydown'];

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /*
   * The `autoplay` attribute is a request, not a guarantee. Browsers refuse it under Low
   * Power Mode (iOS), Data Saver (Android), and some engagement heuristics — and when they
   * do, nothing retries. Waiting for the visitor's first gesture costs nothing and is the
   * only thing that rescues those cases: the gesture makes the playback "user-initiated".
   */
  function playOnFirstGesture(video) {
    function resume() {
      for (var i = 0; i < GESTURES.length; i++) {
        document.removeEventListener(GESTURES[i], resume);
      }
      video.muted = true;
      video.play().catch(function () {});
    }

    for (var i = 0; i < GESTURES.length; i++) {
      document.addEventListener(GESTURES[i], resume, { passive: true });
    }
  }

  function initBackgroundVideos() {
    var reduced = prefersReducedMotion();
    var videos = document.querySelectorAll('.background-video__player video');

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];

      if (reduced) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        continue;
      }

      /*
       * Set muted and playsinline as PROPERTIES, not just parse-time attributes. Safari
       * re-evaluates both when it decides whether unattended playback is allowed, and an
       * element that was moved, cloned or re-rendered can lose the attribute's effect.
       */
      video.muted = true;
      video.setAttribute('playsinline', '');

      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(playOnFirstGesture.bind(null, video));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackgroundVideos);
  } else {
    initBackgroundVideos();
  }
  } catch(e) { console.error(e); }
})();

})();
